<template lang="html">
  <main :class="{ full: fullScreen }">
    <nav-header v-if="!fullScreen" />

    <section class="content">
      <router-view />
    </section>
  </main>
</template>

<script>
import { mapState } from 'vuex';

import NavHeader from './nav/NavHeader';

export default {
  components: {
    NavHeader,
  },

  computed: {
    ...mapState({
      fullScreen: ({ global }) => global.fullScreen,
    }),
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss" scoped>
  main.full {
    height: 100%;

    .content {
      padding: 0;
      height: 100%;
    }
  }

  .content {
    padding-top: $nav-height;
    padding-bottom: $gp * 2;
  }
</style>
